import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Box from '../Box';

function Progress(props) {
  var value = props.value,
      _props$activeColor = props.activeColor,
      activeColor = _props$activeColor === void 0 ? 'primary' : _props$activeColor,
      restProps = _objectWithoutPropertiesLoose(props, ["value", "activeColor"]);

  return /*#__PURE__*/React.createElement(Box, _extends({
    role: "progressbar",
    "aria-valuenow": value,
    width: "100%",
    height: 0.5,
    radius: 6,
    position: "relative",
    overflow: "hidden",
    backgroundColor: "grey-3"
  }, restProps), /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    transformOrigin: "center left",
    backgroundColor: activeColor,
    style: {
      transform: "scaleX(" + value / 100 + ")"
    }
  }));
}

export default Progress;